import { BLOG_POSTS, formatDate, type BlogPost } from './blog'
import { CtaBand, Crumbs, FaqList, Related, Rich, Sections, plain, type QA, type Section } from './content'
import { ORGANIZATION_ID, SITE_URL, OG_IMAGE, breadcrumbList, type Crumb, type PageMeta } from './meta'
import { SiteShell } from './SiteShell'

export interface ArticleData {
  path: string
  lead: string
  sections: Section[]
  faq?: QA[]
  related?: string[]
}

const BLOG: Crumb = { name: 'Блог', path: '/blog' }

function post(path: string): BlogPost {
  const found = BLOG_POSTS.find((p) => p.path === path)
  if (!found) throw new Error(`${path} is not in BLOG_POSTS (src/site/blog.ts)`)
  return found
}

function trail(p: BlogPost): Crumb[] {
  return [{ name: 'Головна', path: '/' }, BLOG, { name: p.title, path: p.path }]
}

export function articleMeta(article: ArticleData): PageMeta {
  const p = post(article.path)
  return {
    title: `${p.title} | Anytel`,
    description: p.description,
    updated: p.published,
    schema: [
      {
        '@type': 'BlogPosting',
        headline: p.title,
        description: plain(p.description),
        datePublished: p.published,
        inLanguage: 'uk',
        image: SITE_URL + OG_IMAGE.path,
        mainEntityOfPage: SITE_URL + p.path,
        author: { '@id': ORGANIZATION_ID },
        publisher: { '@id': ORGANIZATION_ID },
      },
      breadcrumbList(trail(p)),
    ],
  }
}

export function ArticlePage({ article }: { article: ArticleData }) {
  const p = post(article.path)
  return (
    <SiteShell>
      <main id="main" className="lp-page">
        <article>
          <div className="lp-wrap">
            <Crumbs items={trail(p)} />
            <header className="lp-page-head lp-article-head">
              <p className="lp-eyebrow">Блог</p>
              <h1>{p.title}</h1>
              <p className="lp-article-meta">
                <time dateTime={p.published}>{formatDate(p.published)}</time> · {p.minutes} хв читання
              </p>
              <p className="lp-page-lead"><Rich text={article.lead} /></p>
            </header>
          </div>
          <div className="lp-wrap lp-prose"><Sections sections={article.sections} /></div>
          {article.faq && (
            <section className="lp-wrap lp-page-faq">
              <h2>Питання і відповіді</h2>
              <FaqList items={article.faq} />
            </section>
          )}
        </article>
        <CtaBand />
        {article.related && <Related paths={article.related} title="Що почитати далі" />}
      </main>
    </SiteShell>
  )
}
